import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  transcriptionLoading: false,  
  TSstatus: "inactive",          
  isOwner: false,               
  TSChecking: false,             
  transcription: "",
  translation: "",
  detectedLang: null,
  targetLang: "fr",
  sttLanguageOptions: [],
  translationLanguageOptions: [],
  sttSourceLang: "",
  translationTargetLang: "fr",
  TSNotif: null,                 
  owner: null,                  
  transcriptionActive: false,    
};

const transcriptionSlice = createSlice({
  name: "transcription",
  initialState,
  reducers: {
    setTranscriptionLoading: (state, action) => {
      state.transcriptionLoading = action.payload;
    },

   setTranscriptionState: (state, action) => {
  const { TSstatus, isOwner, TSChecking, transcription, owner } = action.payload;

  if (TSstatus !== undefined) {
    const hasChanged = TSstatus !== state.TSstatus;
    state.TSstatus = TSstatus;
    state.transcriptionActive = TSstatus === "active";

    if (hasChanged) {
      state.TSNotif =
        TSstatus === "active"
          ? "Transcription Activée"
          : TSstatus === "inactive"
          ? "Transcription Désactivée"
          : TSstatus === "pending"
          ? "Activation en cours"
          : null;
    }
  }

  if (isOwner !== undefined) state.isOwner = isOwner;
  if (TSChecking !== undefined) state.TSChecking = TSChecking;
  if (transcription !== undefined) state.transcription = transcription;
  if (owner !== undefined) state.owner = owner;

  const { translation, detectedLang, targetLang } = action.payload;
  if (translation !== undefined) state.translation = typeof translation === "string" ? translation : "";
  if (detectedLang !== undefined) state.detectedLang = detectedLang;
  if (targetLang !== undefined) state.targetLang = typeof targetLang === "string" ? targetLang : "en";

  const {
    sttLanguageOptions,
    translationLanguageOptions,
    sttSourceLang,
    translationTargetLang,
  } = action.payload;
  if (sttLanguageOptions !== undefined) {
    state.sttLanguageOptions = Array.isArray(sttLanguageOptions) ? sttLanguageOptions : [];
  }
  if (translationLanguageOptions !== undefined) {
    state.translationLanguageOptions = Array.isArray(translationLanguageOptions)
      ? translationLanguageOptions
      : [];
  }
  if (sttSourceLang !== undefined) {
    state.sttSourceLang = typeof sttSourceLang === "string" ? sttSourceLang : "";
  }
  if (translationTargetLang !== undefined) {
    state.translationTargetLang =
      typeof translationTargetLang === "string" ? translationTargetLang : "";
  }
},

    clearTranscription: (state) => {
      state.transcriptionLoading = false;
      state.TSstatus = "inactive";
      state.isOwner = false;
      state.TSChecking = false;
      state.transcription = "";
      state.translation = "";
      state.detectedLang = null;
      state.targetLang = "fr";
      state.sttLanguageOptions = [];
      state.translationLanguageOptions = [];
      state.sttSourceLang = "";
      state.translationTargetLang = "fr";
      state.owner = null;
      state.TSNotif = null;
      state.transcriptionActive = false;
    },

    transcriptionStarted: (state) => {
      state.TSstatus = "active";
      state.transcriptionActive = true;
    },
    transcriptionStopped: (state) => {
      state.TSstatus = "inactive";
      state.transcriptionActive = false;
    },

    setOwner: (state, action) => {
      state.owner = action.payload;
    },
    setTranscriptionText: (state, action) => {
      state.transcription = action.payload;
    },
    setNotification: (state, action) => {
      state.TSNotif = action.payload;
    },
  },
});

export const {
  setTranscriptionLoading,
  setTranscriptionState,
  clearTranscription,
  transcriptionStarted,
  transcriptionStopped,
  setOwner,
  setTranscriptionText,
  setNotification,
} = transcriptionSlice.actions;

export default transcriptionSlice.reducer;
